import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, mergeMap, tap } from 'rxjs/operators';
import { ArianeeService } from '../../../providers/arianee-service/arianee.service';

import { BrowserService } from '../../../providers/inapp-browser/inapp-browser-service';
import { NavController } from '@ionic/angular';
import { from, Subscription } from 'rxjs';
import { EventLoggerService } from '../../../providers/event-logger/event-logger-service';

import { Location } from '@angular/common';
import { DisplayMapperService } from '@arianeeprivate/wallet-shared-components';

import { PoapService } from '../../../providers/poap/poap.service';
import {
  ArianeeBlockchainProxyService
} from '../../../providers/arianee-blockchain-proxy-service/arianee-blockchain-proxy-service';

@Component({
  selector: 'app-brand-page',
  templateUrl: './brand-page.page.html',
  styleUrls: ['./brand-page.page.scss']

})

export class BrandPage implements OnInit, OnDestroy {
  public identity:any;
  public brandId:string;
  public seeMore:boolean;
  private subscritions:Subscription[]=[];

  constructor (
    private route: ActivatedRoute,
    private arianeeService: ArianeeService,
    private browserService: BrowserService,
    private navCtrl: NavController,
    private eventLogger: EventLoggerService,
    private location:Location,
    private displayMapperService:DisplayMapperService,
    private poapService:PoapService,
    private arianeeBlockchainProxyService : ArianeeBlockchainProxyService
  ) {

  }

  ionViewDidEnter () {
    this.eventLogger.logScreen('brand-page', { brandId: this.brandId });
  }

  ngOnInit () {
    this.brandId = this.route.snapshot.paramMap.get('brandId');

    if (this.brandId == this.poapService.poapAddress) {
      const sub = this.poapService.getPoapIdentity()
        .pipe(
          map(identity => this.displayMapperService.brandDisplayMapper(identity)),

          tap(identity => { this.seeMore = identity.brandDescription.length > 1000; })
        )
        .subscribe(identity => {
          identity.brandExternalContent = identity.brandExternalContent.filter(externalContent => { return !['deepLinkDomain', 'hostedWallet'].includes(externalContent.type); });
          this.identity = identity;
        });
      this.subscritions.push(sub);
    } else {
      const sub = this.fetchIdentity()
        .pipe(
          tap(identity => { this.seeMore = identity.brandDescription.length > 1000; })
        )
        .subscribe(identity => {
          identity.brandExternalContent = identity.brandExternalContent.filter(externalContent => { return !['deepLinkDomain', 'hostedWallet'].includes(externalContent.type); });
          this.identity = identity;
        });
      this.subscritions.push(sub);
    }
  }

  ngOnDestroy () {
    this.subscritions.forEach(sub => sub.unsubscribe());
  }

  fetchIdentity () {
    return this.arianeeService.$address
      .pipe(
        mergeMap(address => this.arianeeBlockchainProxyService.getIdentity(this.brandId)),
        map(identity => this.displayMapperService.brandDisplayMapper({ data: identity }))
      );
  }

  toggleSeeMore () {
    this.seeMore = !this.seeMore;
  }

  openSocial (social) {
    switch (social.type) {
      case 'twitter':
        this.browserService.openTwitter(social.value);
        break;
      case 'instagram':
        this.browserService.openInstagram(social.value);
        break;
      case 'youtube':
        this.browserService.openYoutube(social.value);
        break;
      case 'facebook':
        this.browserService.openFacebook(social.value);
        break;
      default:
        this.browserService.openBrowser(social.value);
        break;
    }
  }

  onClickNavBack () {
    this.location.back();
  }

  openLink (link) {
    this.browserService.openBrowser(link.url);
  }
}
